module.exports = __webpack_public_path__ + "static/media/007.b4de9d7a.jpg";